<bz-loading [showLoading]="showLoading">
</bz-loading>


<ng-form class="bmc-ecm-form" #propertiesForm="ngForm">
    <div class="bmc-ecm-properties" *ngIf="!showLoading">
        <div *ngFor="let property of metadata | keyvalue">
          <div class="bmc-ecm-properties__field" *ngIf="property.key !== 'description'">
            <div class="bmc-ecm-properties-property">
              <label class="bmc-ecm-properties-property__field">{{'ECM.' + property.key | uppercase | translate}}</label>
            </div>
            <div class="bmc-ecm-properties-value">
              <bzg-input name="{{property.key}}text" type='text' *ngIf="property.value.type === 'text'" [required]="true"
                [maxlength]="property.value.max === -1 ? undefined : property.value.max" [(ngModel)]="selectedRepository.environment.params[property.key]"
                placeholder="{{ 'GLOBAL.EMPTY' | translate }}">
                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
              </bzg-input>
              <bzg-input name="{{property.key}}text" *ngIf="property.value.type === 'password'" [required]="property.value.required" type = "password"
                name="property.key" [(ngModel)]="selectedRepository.environment.params[property.key]">
                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
              </bzg-input>
              <bzg-input name="{{property.key}}text" [type]="'number'" [min]="property.value.min" [max]="property.value.max"
                [required]="property.value.required" (keypress)="utilsService.onlyNumbers($event)"
                *ngIf="property.value.type === 'number'" [(ngModel)]="selectedRepository.environment.params[property.key]"
                placeholder="{{ 'GLOBAL.EMPTY' | translate }}">
                <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
                <bzg-max-error>{{'GLOBAL.INVALID_MAX_VALUE' | translate}} {{property.value.max}}</bzg-max-error>
                <bzg-min-error>{{'GLOBAL.INVALID_MIN_VALUE' | translate}} {{property.value.min}}</bzg-min-error>
              </bzg-input>
            </div>
          </div>
        </div>
        <div class="bmc-ecm-properties__field bmc-ecm-properties__field--repository"
          *ngIf="selectedRepository.environment.params.repositoryName">
          <div class="bmc-ecm-properties-property">
            <label class="bmc-ecm-properties-property__field">{{'ECM.REPOSITORY' | translate}}</label>
          </div>
          <div class="bmc-ecm-properties-value bmc-ecm-properties-value--repository">
            <label>{{selectedRepository.environment.params.repositoryName}}</label>
          </div>
        </div>

        <div class="bmc-ecm-properties__field bmc-ecm-properties__field--repository" *ngIf="repositories && repositories.length">
          <div class="bmc-ecm-properties-property">
            <label class="bmc-ecm-properties-property__field">{{'ECM.REPOSITORIES' | translate}}</label>
          </div>
          <div class="bmc-ecm-properties-value bmc-ecm-properties-value--repository">
            <div class="bmc-ecm-properties__repositories">
              <bzg-checkbox (change)="selectRepository(repository, $event)" [disabled]="initialExternalRepositoryId"
                [checked]="repository.Id === selectedRepository.environment.params.externalId"
                *ngFor="let repository of repositories" class="bmc-ecm-properties__repositories__checkbox">
                {{repository.Value}}
              </bzg-checkbox>
            </div>
          </div>
        </div>

        <div class="bmc-ecm-properties-buttons">
          <bzg-button-primary (click)="connectToRepositories()" *ngIf="!isConnectedToRepositories">
            {{'ECM.CONNECT' | translate}}
          </bzg-button-primary>
          <bzg-button-primary (click)="connectToRepositories()" *ngIf="isConnectedToRepositories">
            {{'ECM.RECONNECT' | translate}}</bzg-button-primary>
        </div>
      </div>
</ng-form>
